import { AnnualReportStep, IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';
import { DEFAULT_AR_NAVIGATION } from '../constants/default-ar-navigation';

export class AnnualReportStepsHelper {
    // The one rule for a report's steps, shared by the sidebar and the print page for every
    // report type, interim included — a step the user can fill in must also be printable.
    public static getTemplateStepsOrDefault(annualReport: IAnnualReport | null | undefined): AnnualReportStep[] {
        const templateSteps = annualReport?.annualReportTemplate?.annualReportSteps;
        return templateSteps != null && templateSteps.length > 0 ? templateSteps : DEFAULT_AR_NAVIGATION;
    }

    public static getAnnualReportSteps(
        annualReportSteps: AnnualReportStep[],
        isFcpActive: boolean,
    ): AnnualReportStep[] {
        if (!isFcpActive) {
            return annualReportSteps;
        }

        const updatedSteps = [...annualReportSteps];
        const importStepIndex = this.getImportStepIndex(updatedSteps);

        if (importStepIndex !== -1) {
            updatedSteps.splice(importStepIndex + 1, 0, AnnualReportStep.FINANCIAL_CLOSING_PROCESS);
        } else {
            updatedSteps.push(AnnualReportStep.FINANCIAL_CLOSING_PROCESS);
        }

        return updatedSteps;
    }

    private static getImportStepIndex(annualReportSteps: AnnualReportStep[]): number {
        return annualReportSteps.indexOf(AnnualReportStep.IMPORT_BALANCE_INCOME);
    }
}
